import { format } from 'date-fns'
import { Row, Col, Button } from '@deere/ux.uxframe-react'
import { ReactComponent as PrintIcon } from '@deere/ux.brand-foundations/icons/print.svg';
import { useTranslation } from "react-i18next";
import { getDateFromTimeStamp } from "../../utils/utils"
import { MUST_CLICK_SUBMIT } from '../../utils/surveyLiterals';

export default function CMTitle({ survey, assignment, latestResponse, handlePrint, showReviewSuggestion }) {
  const { t } = useTranslation();
  let dateCheck = false;
  if(new Date(survey.endDate).getTime() < new Date().getTime()){
    dateCheck = true;
  }
  return (
    <Col xs={24} md={24}>
      <Row>
        <Col xs={24} md={24}>
          <h1>{survey.description}</h1>
        </Col>
      </Row>
      <Row>
        <Col xs={20} md={21}>
          <h5>{t("lbl_survey_current_request")} {assignment.id}- {assignment.supplierName}</h5>
            {
              dateCheck ? (<h5>{t("lbl_survey_due_date")} <span style={{ color: 'red' }}>{survey.endDate}</span></h5>) :
              <h5>Due date {survey.endDate}</h5>
            } 
          <h5>{latestResponse && (latestResponse.userName || latestResponse.createdBy) ? ` ${t("lbl_last_save")} ${getDateFromTimeStamp(new Date(latestResponse.lastUpdatedTs))} by ${latestResponse.userName ? latestResponse.userName + ' ' + latestResponse.createdBy : latestResponse.createdBy}` : ''}</h5>
          {showReviewSuggestion && <h5 style={{ color: "red", fontWeight: "bold" }}>{MUST_CLICK_SUBMIT}</h5>}
        </Col>
        {handlePrint && <Col xs={3} md={3} style={{ textAlign: 'right', display: 'flex', alignItems: 'flex-end' }}><Button variant="secondary" className="d-print-none" onClick={handlePrint} > <PrintIcon size='sm' />{t('rev_print')}</Button></Col>}
      </Row>
    </Col>);
}